import UpArrow from '@assets/images/asc.svg';
import DownArrow from '@assets/images/desc.svg';

export function getSortIcon(sortType?: 'asc' | 'desc') {
  if (sortType === 'asc') {
    return <UpArrow />;
  } else if (sortType === 'desc') {
    return <DownArrow />;
  }
  return '';
}

export function getStartItem(page: number, rowsPerPage: number) {
  return page * rowsPerPage + 1;
}

export function getEndItem(
  page: number,
  rowsPerPage: number,
  totalItems: number
) {
  return Math.min((page + 1) * rowsPerPage, totalItems);
}
